import { startsWithSegment } from 'router5-helpers';

export function calculateSelectedTab(routeName: string) {
  if (startsWithSegment(routeName, 'project.runs-tab')) {
    return 'runs';
  }

  if (startsWithSegment(routeName, 'project.trash')) {
    return 'trash';
  }

  if (startsWithSegment(routeName, 'project.reports')) {
    return 'reports';
  }
}
